import Vue from 'vue'
import ApiService from '@/common/api.service'

export const state = {
  /*
   * driverSelectionSets is a "grouping" of multiple drivers that are
   * selected. For example, one might wish to have a "global" set of
   * selected drivers that is persistent across all screens or one
   * might want to create a set of selected drivers for a particular
   * individual/group of widgets.
   */
  driverSelectionSets: {},
  queryByClient: null,
  queryByGroups: []
}

export const getters = {
  /**
   * Returns the full state object
   *
   * @param state Object
   *
   * @return Object
   */
  get (state) {
    return state
  },

  /**
   * Returns the sets of selected drivers.
   *
   * @param state Object
   *
   * @return Object
   */
  driverSelectionSets (state) {
    return state.driverSelectionSets
  },

  /**
   * Returns either a client object or null depending on whether
   * queries should be made by client.
   *
   * @param state
   *
   * @return {Object|null}
   */
  getClient (state) {
    return state.queryByClient
  }
}

export const actions = {
  /**
   * Query/find one or more drivers.
   *
   * @param context Object
   * @param params  Array of query key's and values
   *
   * @return Promise
   */
  query (context, params) {
    const queryByClient = context.getters['getClient']

    if (queryByClient !== null) {
      return ApiService
        .get(`drivers/by-client/${queryByClient.id}`, params)
        .then((response) => {
          return response
        })
    } else {
      return ApiService
        .get(`drivers`, params)
        .then((response) => {
          return response
        })
    }
  }
}

export const mutations = {
  /**
   * Add a map or array of object drivers that have been selected within
   * the specified set.
   *
   * @param state    Object
   * @param set      String
   * @param drivers Array|Map
   */
  addSelectedDrivers (state, { set, drivers }) {
    if (!state.driverSelectionSets.hasOwnProperty(set)) {
      Vue.set(state.driverSelectionSets, set, {})
    }

    drivers.forEach(driver => {
      Vue.set(state.driverSelectionSets[set], driver.id, driver)
    })
  },

  /**
   * Removes an array of drivers from the set's list of selected drivers.
   * The array must consist of the id's of the drivers that are no
   * longer selected.
   *
   * @param state    Object
   * @param set      String
   * @param drivers Array
   */
  removeSelectedDrivers (state, { set, drivers }) {
    if (state.driverSelectionSets.hasOwnProperty(set)) {
      drivers.forEach(driver => {
        Vue.delete(state.driverSelectionSets[set], driver.id)
      })
    }
  },

  /**
   * Clears all selected drivers.
   *
   * @param state  Object
   */
  clearAllSelectedDrivers (state) {
    Vue.set(state, 'driverSelectionSets', {})
  },

  /**
   * Clears all selected drivers within a specified set.
   *
   * @param state  Object
   * @param set      String
   */
  clearSelectedDrivers (state, set) {
    if (state.driverSelectionSets.hasOwnProperty(set)) {
      Vue.set(state.driverSelectionSets, set, {})
    }
  },

  /**
   * Purge the module's state.
   *
   * @param state Object
   */
  purge (state) {
    state.driverSelectionSets = {}
    state.queryByClient = null
    state.queryByGroups = []
  },

  /**
   * Sets the client for which the drivers should be queried.
   *
   * @param state
   *
   * @param client Object|null
   */
  setClient (state, client) {
    state.queryByClient = client
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/assets/drivers/findDriversWidgetModule.js